<template>
  <div class="wrap">
    <header style=" display: flex;justify-content: center;">
      <span style="position: absolute;left: 20px;" class="left iconfont icon-back-left" @click="goBack"></span>
      <h1>{{lang.bdxx}}</h1>
    </header>
    <div class="main">
      <div class="title">{{lang.bdxx}}</div>
      <div class="telmode">
        <label><span>{{lang.zsxm}}</span><input type="text" v-model.trim="formData.rname" :placeholder="lang.enrname" /></label>
        <label><span>{{lang.mobile}}</span><input type="text" v-model.trim="formData.mobile" :placeholder="lang.enmobile" /></label>
        <label><span>{{lang.email}}</span><input type="text" v-model.trim="formData.email" :placeholder="lang.enemail" /></label>
      </div>
      <div class="title">{{lang.yhkxx}}</div>
      <div class="telmode">
        <label @click="openPopup">
          <span>{{lang.khh}}</span>
          <input tpye="text" :placeholder="lang.sbank" v-model.trim="formData.bankName" readonly />
          <i class="iconfont icon-back-right"></i>
        </label>
        <label><span>{{lang.bankacc}}</span><input type="number" v-model.trim="formData.bankAcc"
            :placeholder="lang.enbankacc" /></label>
<!--        <label><span>{{lang.IFSC}}</span><input type="text" v-model.trim="formData.IFSC"-->
<!--            :placeholder="lang.enIFSC" /></label>-->
<!--        <label><span>{{lang.UPI}}</span><input type="text" v-model.trim="formData.UPI" :placeholder="lang.enUPI" /></label>-->
        <label><span>{{lang.aqcode}}</span><input type="password" v-model.trim="formData.sepwd"
            :placeholder="lang.aqcode" /></label>
      </div>
      <div class="next-btn" v-if="!isbing" @click="submit">{{lang.confirm}}</div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom" class="bank-list">
      <ul>
        <li @click="choseBank(item)" v-for="(item,index) in bankList" :key="index">{{item}}</li>
      </ul>
    </mt-popup>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex'
  import router from "../../router";
  export default {
    data() {
      return {
        showsepwd: false,
        sepwd: '',
        sepwdNew: '',
        popupVisible: false,
        bankList: [],
        formData: {
          mobile: '',
          email: '',
          rname: '',
          sepwd:'',
          bankAcc: '',
          bankName: '',
        },
        newFromData: {},
        oldFromData: {},
        isreadonly: {
          mobile: false,
          email: false,
          rname: false,
          bankName: false,
          bankAcc: false,
          IFSC: false,
          UPI: false
        },
        isbing: false //是否绑定
      }
    },
    computed: {
      ...mapState(['lang', 'userInfo'])
    },
    created() {
      this.getData()
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      choseBank(name) {
        this.popupVisible = false;
        this.formData.bankName = name;
      },
      openPopup() {
        if (this.bankList.length&&!this.isbing) this.popupVisible = true;
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/bindInfo')
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.formData.mobile = res.data.data.mobile;
              this.formData.email = res.data.data.email;
              this.formData.rname = res.data.data.rname;
              this.formData.bankName = res.data.data.bankName;
              this.formData.bankAcc = res.data.data.bankAcc;
              this.formData.sepwd = res.data.data.sepwd;
              this.bankList = res.data.bankList;
              this.isbing = res.data.isBand;
              this.oldFromData = {
                ...this.formData
              };
              for (let i in this.formData) {
                if (this.formData[i]) {
                  this.isreadonly[i] = true
                }
              }
            } else if (res.data.err == 102||res.data.err == 106) {
              this.$router.push('Login');
              sessionStorage.setItem('tk', res.data.tk);
              router.push("login")
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      },
      submit() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/member/bindInfo', {
            ...this.formData
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.$toast({
                message: res.data.msg,
                iconClass: 'iconfont icon-chenggong',
                duration: 2000
              })
              this.goBack();
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              sessionStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      }
    }
  }
</script>
<style type="text/css"  scoped>
  .main  .title {
    font-size: 16px;
    padding-left: 12px;
    color: #000;
    line-height: 40px;
    font-weight: bold;
  }

  .main .telmode {
    margin: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 5px 6px rgba(0, 0, 0, .1);
  }
  .main .telmode label {
    display: flex;
    height: 40px;
    align-items: center;
  }
  .main .telmode label span {
    width: 100px;
    color: #999;
  }

  .main .telmode label input {
    flex: 1;
    padding-left: 12px;
  }


  .main .next-btn {
    margin: 30px 30px 0;
    background: linear-gradient(to right, #3476fe, #34c7fe);
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 30px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }

  .bank-list {
    width: 100%;
    background: #fff;
    max-height: 400px;
    overflow-y: auto;
  }
  li {
    height: 44px;
    line-height: 44px;
    border-bottom: 1px solid #ddd;
    padding: 0 12px;
    color: #666;
  }

</style>